import 'babel-polyfill';
import './sass/main.scss';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import configureStore from './javascript/state/store';
import App from './javascript';
import initSentry from './sentry'

initSentry();

document.addEventListener('DOMContentLoaded', () => {
	const initialState = window.__INITIAL_STATE__;
	const store = configureStore(initialState);

	ReactDOM.render(<Provider store={store}><App /></Provider>, document.querySelector('main'));
});
